module.exports = __webpack_public_path__ + "assets/match.e3883a0a.svg";